var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class DirectvNetwork {
    constructor(log) {
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                path: /\/info\/getVersion/i,
                method: 'get',
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const response = {
                        DMA: 81,
                        accessCardId: '0046-0534-5620',
                        isEmployeeAccount: false,
                        locationName: 'A',
                        manufacturer: '500',
                        modelId: 89,
                        receiverId: '0235 8402 3503',
                        status: {
                            code: 200,
                            commandResult: 0,
                            msg: 'OK.',
                            query: '/info/getVersion',
                        },
                        stbSoftwareVersion: '0x19ea',
                        systemTime: Date.now(),
                        version: '2.5',
                    };
                    return this.makeResponse(req, JSON.stringify(response));
                }),
            },
            {
                name: 'channelSet',
                path: /\/tune\?major=(\d+)(?:&minor=(\d+))?/i,
                method: 'get',
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const response = {
                        status: {
                            code: 200,
                            commandResult: 0,
                            msg: 'OK.',
                            query: `/tv/tune?major=${match[1]}${match[2] !== undefined ? '&minor=' + match[2] : ''}`,
                        },
                    };
                    return this.makeResponse(req, JSON.stringify(response));
                }),
            },
            {
                name: 'keyress',
                path: /\/remote\/processKey\?key=(.+)/i,
                method: 'get',
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const response = {
                        hold: 'keyPress',
                        key: match[1],
                        status: {
                            code: 200,
                            commandResult: 0,
                            msg: 'OK.',
                            query: `/remote/processKey?key=${match[1]}`,
                        },
                    };
                    return this.makeResponse(req, JSON.stringify(response));
                }),
            },
        ];
    }
    makeResponse(request, result) {
        return {
            status: 200,
            headers: {
                'okhttp-response-source': 'NETWORK 200',
                'keep-alive': 'timeout=60',
                'content-length': `'${result.length}'`,
                'cache-control': 'no-store',
                'okhttp-selected-protocol': 'http/1.1',
                'content-type': 'application/json',
                charset: 'utf-8',
            },
            data: result,
        };
    }
}
DirectvNetwork.emulatorType = 'httpRequestEmulator';
DirectvNetwork.key = '-NziLf9sDdTxGK_sM_mG';
